import { useEffect, useRef } from 'react';

const useMountedRef = () => {
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return mounted;
};

export default useMountedRef;
